module.exports = __webpack_public_path__ + "img/143.9dacee8b.jpg";